import React, {useCallback, useEffect, useState} from "react";
import {deleteSkill, updateSkill} from "../../../../service/adminService";
import {Button, ButtonToolbar, Form, Modal, SelectPicker, Stack} from "rsuite";
import {adminSkillModel} from "../../../form/models";

const EditAdminSkillModal = (props) => {
  const { open, handleClose, selectedSkill, skillTypes } = props

  const [localState, setLocalState] = useState();

  useEffect(() => {
    setLocalState({...selectedSkill});
  }, [selectedSkill]);

  const submitAdminSkillEdit = (isFormValid) => {
    if(!isFormValid) return;
    updateSkill(localState).then((response) => {
      handleClose(response);
    });
  };

  const submitAdminSkillDelete = useCallback(() => {
    deleteSkill({id: localState.id}).then((response) => {
      handleClose(response);
    });
  }, [handleClose, localState]);

  // rsuite does not have an onSubmit, we must handle state changes per controlled field
  const handleFormChange = (event) => {
    setLocalState({...localState, ...event});
  }

  return (
      <Modal
          open={open}
          onClose={handleClose}
          backdrop="static"
      >
        <Modal.Header>
          <Modal.Title>Edit Skill</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <Stack spacing={2} direction='column' alignItems='flex-start'>
            <p>
              Changes/removal will cascade to all user resumes with that existing skill.
            </p>
            <p>
              <b>Warning:</b> Deleting a skill will remove the skill for ALL users.
            </p>
          </Stack>
        </Modal.Body>
        <Form
            layout="horizontal"
            model={adminSkillModel}
            onChange={handleFormChange}
            onSubmit={submitAdminSkillEdit}
            formDefaultValue={selectedSkill}
        >
          <Form.Group>
            <Form.ControlLabel>Skill Name</Form.ControlLabel>
            <Form.Control name="skillName"/>
          </Form.Group>
          <Form.Group>
            <Form.ControlLabel>Skill Type</Form.ControlLabel>
            <Form.Control name="skillType"
                          accepter={SelectPicker}
                          data={skillTypes}
            />
          </Form.Group>
          <Form.Group>
            <ButtonToolbar>
              <Button type="submit" appearance="primary">
                Ok
              </Button>
              <Button onClick={handleClose} appearance="default">
                Cancel
              </Button>
              <Button onClick={submitAdminSkillDelete} appearance="primary" color="red">
                Delete Skill
              </Button>
            </ButtonToolbar>
          </Form.Group>
        </Form>
      </Modal>
  );
};


export default EditAdminSkillModal;